<template>
  <div class="d-flex justify-content-center">
    <canvas ref="doughnut" />
  </div>
</template>

<script>
export default {
  name: 'DoughnutChart',

  props: {
    height: {
      default: 250,
      type: Number
    },
    value: {
      required: true,
      type: Object
    },
    width: {
      default: 250,
      type: Number
    }
  },

  data: () => ({
    canvas: null,
    colorAssignments: {},
    colors: [
      '#6a5999',
      '#147b90',
      '#64a2a2',
      '#81cec1',
      '#c2caa1',
      '#ebd7a9',
      '#f16364',
      '#964796'
    ],
    ctx: null,
    doughnutHoleSize: 0.5
  }),

  computed: {
    totalValue () {
      let total = 0

      for (const index in this.value) {
        total += this.value[index]
      }

      return total
    }
  },

  mounted () {
    this.init()
    this.draw()
  },

  methods: {
    draw () {
      let colorIndex = 0
      let startAngle = 0

      for (const index in this.value) {
        const value = this.value[index]
        const sliceAngle = 2 * Math.PI * value / this.totalValue

        this.drawPieSlice(
          Math.min(this.canvas.width / 2, this.canvas.height / 2),
          startAngle,
          startAngle + sliceAngle,
          this.colors[colorIndex % this.colors.length]
        )

        this.colorAssignments[index] = this.colors[colorIndex]

        startAngle += sliceAngle
        colorIndex++
      }

      this.drawPieSlice(
        this.doughnutHoleSize * Math.min(this.canvas.width / 2, this.canvas.height / 2),
        0,
        2 * Math.PI,
        '#ffffff'
      )

      this.$emit('colors', this.colorAssignments)
    },

    drawArc (centerX, centerY, radius, startAngle, endAngle) {
      this.ctx.beginPath()
      this.ctx.arc(centerX, centerY, radius, startAngle, endAngle)
      this.ctx.stroke()
    },

    drawLine (startX, startY, endX, endY) {
      this.ctx.beginPath()
      this.ctx.moveTo(startX, startY)
      this.ctx.lineTo(endX, endY)
      this.ctx.stroke()
    },

    drawPieSlice (radius, startAngle, endAngle, color) {
      const centerX = this.canvas.width / 2
      const centerY = this.canvas.height / 2

      this.ctx.fillStyle = color
      this.ctx.beginPath()
      this.ctx.moveTo(centerX, centerY)
      this.ctx.arc(centerX, centerY, radius, startAngle, endAngle)
      this.ctx.closePath()
      this.ctx.fill()
    },

    init () {
      this.canvas = this.$refs.doughnut
      this.canvas.height = this.height
      this.canvas.width = this.width

      this.ctx = this.canvas.getContext('2d')
    }
  }
}
</script>
